<div style="max-width: 90vw">
  <div mat-dialog-title>
    <h5 i18n>Export Report</h5>
  </div>
  <p *ngIf="!isMobile" i18n>Choose Export Format</p>

  <div mat-dialog-content>
    <form #exportForm="ngForm" (ngSubmit)="submitReportExport(exportForm)">

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <select name="locale" class="form-control select-bidit" [(ngModel)]="locale">
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button type="button" (click)="exportClick({format:'EXCELOPENXML', extension: '.xlsx'})" class="btn btn-bidit-submit mr-2" i18n>Excel</button>
          <button type="button" (click)="exportClick({format:'PDF', extension: '.pdf'})" class="btn btn-bidit-submit mr-2" i18n>Print</button>
          <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
